import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { formatDate as formatDateFromUtils } from "@/utils/dateFormatter";

/**
 * A helper function (cn) to merge Tailwind classes.
 * This is the standard in most modern React projects.
 * It intelligently combines default classes, variant classes,
 * and custom classes passed via props, preventing conflicts.
 * * Example: cn("p-2", "p-4") => "p-4" (p-4 wins)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateInput, formatStr, fallback) =>
  formatDateFromUtils(dateInput, formatStr, fallback);
